import React from 'react';
import { Link } from 'react-router-dom';
import Tilt from '../../../Components/Fx/Tilt';

const partyTone = (party?: string) => {
   const p = (party || '').toLowerCase();
   if (p.startsWith('dem')) return 'border-blue-400/30 bg-blue-400/10 text-blue-200';
   if (p.startsWith('rep')) return 'border-signal/40 bg-signal/10 text-signal-soft';
   return 'border-white/15 text-bone-muted';
};

const RepsList = ({ reps }: { reps: any[] }) => {
   const currentYear = new Date().getFullYear();

   return (
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
         {reps.map(rep => {
            const startYear = rep.terms?.item?.[0]?.startYear;
            const yearsInOffice = startYear ? currentYear - startYear : null;

            return (
               <Link to={`${rep.bioguideId}`} key={rep.bioguideId} className="block" data-reveal>
                  <Tilt className="group h-full rounded-sm" max={5}>
                     <article className="relative flex h-full flex-col overflow-hidden rounded-sm border border-white/[0.07] bg-ink-900/60 backdrop-blur-md transition-colors duration-500 group-hover:border-signal/40">
                        <div className="relative aspect-[4/5] overflow-hidden bg-ink-800">
                           {rep.depiction?.imageUrl && (
                              <img
                                 src={rep.depiction.imageUrl}
                                 alt={rep.name}
                                 loading="lazy"
                                 className="h-full w-full object-cover object-top grayscale contrast-110 brightness-90 transition-[transform,filter] duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105 group-hover:grayscale-0"
                              />
                           )}
                           <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/10 to-transparent" />
                           <div className="absolute left-4 top-4 flex flex-wrap gap-1.5">
                              <span className={`chip backdrop-blur-md ${partyTone(rep.partyName)}`}>{rep.partyName}</span>
                           </div>
                           <div className="absolute inset-x-4 bottom-4">
                              <p className="font-mono text-[11px] tracking-[0.2em] text-bone-muted">
                                 {rep.state}
                                 {rep.district ? ` · District ${rep.district}` : ''}
                              </p>
                              <h2 className="mt-1 font-display text-3xl leading-none text-bone">{rep.name}</h2>
                           </div>
                        </div>

                        <div className="flex items-center justify-between px-4 py-4 font-mono text-[11px] uppercase tracking-[0.16em]">
                           <span className="text-bone-dim">
                              {yearsInOffice !== null ? `${yearsInOffice} yrs in office` : 'Member'}
                           </span>
                           <span className="text-bone transition-colors group-hover:text-signal">Profile →</span>
                        </div>
                     </article>
                  </Tilt>
               </Link>
            );
         })}
      </div>
   );
};

export default RepsList;
